module.exports = __webpack_public_path__ + "img/08.4044e107.png";